import React from 'react';
import { FaCrown, FaMapMarkerAlt } from 'react-icons/fa';
import styles from './carolissimastore.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import PerfilLogo from './src/perfil.png';

const BTN_TEXT = '#EDE5D4';

/** Ajuste para os links reais da marca */
const INSTAGRAM_URL = 'https://www.instagram.com/carolissimastore?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const WHATSAPP_NUMBER = '17991896214';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const VIP_URL = 'https://chat.whatsapp.com/F2WlsygNy8H152MFBhbN7x?s=sw&p=a&ilr=0'; // TODO: trocar quando tiver o link do grupo VIP

const Carolissimastore: React.FC = () => {
    return (
        <div className={styles.carolissimastore}>
            <div className={styles['body-thunder']}>
                <div className={styles.topBanner}>
                    <p className={styles.topBannerLead}>
                        Moda feminina e acessórios com o jeitinho Carolíssima. ✨
                    </p>
                    {/* <p className={styles.topBannerSub}>Atendimento personalizado.</p> */}
                </div>
                <div className={styles['container-thunder']}>
                    <div className={styles.profileStack}>
                        <img
                            src={PerfilLogo}
                            className={styles['img-perfil']}
                            alt="Carolíssima Store"
                        />
                        <div className={styles.links}>
                            <a
                                href={INSTAGRAM_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <InstagramIcon height="24" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>INSTAGRAM</span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                className={styles.linkButton}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <WhatsappIcon height="30" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>WHATSAPP</span>
                            </a>
                            <a
                                href={VIP_URL}
                                className={styles.linkButton}
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FaCrown size="22" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>GRUPO VIP</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carolissimastore;
